import { helper } from '@ember/component/helper';

const noopString = 'javascript:void(0)';

export default helper(function noUrlTargetHelper([ url, target ]) {
  url = url && `${url}`.trim();
  return !url || url === noopString ? undefined : target;
});
